import z, { custom, object, ZodIssueCode } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import {
  IS_DATE_VALID,
  IS_REQUIRED,
  IS_TIME_VALID,
} from '@occc-app/lib/constants/validationMessages';
import { isDateTimeValid } from '@occc-app/lib/date';

import { buildValidateDateAndTimeBothSet } from './build-validate-date-and-time-both-set';
import { validatePublishBeforeExpire } from './validate-publish-before-expire';

export const DateSchema = custom<Date>(isDateTimeValid, IS_DATE_VALID).nullable().optional();
export const TimeSchema = custom<Date>(isDateTimeValid, IS_TIME_VALID).nullable().optional();

export const ScheduleDatesSchema = object({
  publishAtDate: DateSchema,
  publishAtTime: TimeSchema,
  expireAtDate: DateSchema,
  expireAtTime: TimeSchema,
})
  .superRefine((data, ctx) => {
    if (!data.publishAtDate) {
      ctx.addIssue({
        code: ZodIssueCode.custom,
        message: IS_REQUIRED,
        path: ['publishAtDate'] satisfies (keyof ScheduleDatesFormValues)[],
      });
    }

    if (!data.publishAtTime) {
      ctx.addIssue({
        code: ZodIssueCode.custom,
        message: IS_REQUIRED,
        path: ['publishAtTime'] satisfies (keyof ScheduleDatesFormValues)[],
      });
    }
  })
  .superRefine(buildValidateDateAndTimeBothSet('expire'))
  .superRefine(validatePublishBeforeExpire);

export type ScheduleDatesFormValues = z.infer<typeof ScheduleDatesSchema>;

export const validateScheduleDatesForm = makeValidate(ScheduleDatesSchema);
